<template>
    <div class="communityButton">
        <v-btn 
        @click="goToCommunity" 
        color="#5fa624"
        density="compact"
        >{{ $t('GO_TO_COMMUNITY') }}</v-btn>
    </div>
</template>
<script>
    import { mapGetters } from "vuex";
    export default {
        name: 'CommunityButton',
        computed: {
            ...mapGetters([
                "user",
            ]),
        },
        methods: {
            goToCommunity() {
                window.open('https://community.ezoic.com', '_blank');
            }
        },
    }
</script>

<style scoped>

.communityButton {
    display: flex;
    justify-content: center;
    position: fixed;
    left: 0;
    right: 0;
    padding: 8px;
    background: rgba(255, 255, 255, 0.9);
    z-index: 1;
    box-shadow: 0 0 5px #ccc;
}

</style>